import {formatCurrency} from '@angular/common';

export function fmtCop(val) {
  return formatCurrency(+val, 'en-us', '$', 'COP', '0.0-0');
}
